import { render, staticRenderFns } from "./OCPrizeGroupTtl.html?vue&type=template&id=4d90f464&scoped=true&"
import script from "./OCPrizeGroupTtl.ts?vue&type=script&lang=ts&"
export * from "./OCPrizeGroupTtl.ts?vue&type=script&lang=ts&"
import style0 from "./OCPrizeGroupTtl.css?vue&type=style&index=0&id=4d90f464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90f464",
  null
  
)

export default component.exports